{
  "loading": "A carregar...",
  "loadingMore": "A carregar mais..."
}
